<template>
	<Popup
		v-model="selfDisplay"
		title="修改"
		confirmBtnText="修改"
		@confirmClick="handleUpdateClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>上传图片</span>
				<div v-if="!banner" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" accept="image/*" @change="handleBannerUpload"/>
					<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
				</div>
				<div v-if="banner" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="banner" alt="" style="">
					<i @click="handleBannerDelete"></i>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="bannerTip"><i class="b_icon"></i>请上传图片</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>标题</span>
				<el-input v-model="title" placeholder="标题"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="titleTip"><i class="b_icon"></i>请输入标题</template></div>
			
			<div class="base_form_row">
				<span class="b_label">链接</span>
				<el-input v-model="link" placeholder="链接"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="linkTip"><i class="b_icon"></i>链接以http或者https开头</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js';
	import BaseMethods from '../../../../../../../assets/js/base.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				banner: '',
				title: '',
				link: '',
				bannerTip: false,
				titleTip: false,
				linkTip: false
			}
		},
		methods: {
			// 点击修改
			handleUpdateClick() {
				if (!this.banner) {
					this.bannerTip = true;
					return false;
				} else {
					this.bannerTip = false;
				}
				if (!this.title.trim()) {
					this.titleTip = true;
					return false;
				} else {
					this.titleTip = false;
				}
				
				
				if (this.link) {
					if (!this.link) {
						this.linkTip = true;
						return false;
					} else {
						this.linkTip = false;
					}
				}
				
				// if (this.link) {
				// 	if (!this.urlReg.test(this.link)) {
				// 		this.linkTip = true;
				// 		return false;
				// 	} else {
				// 		this.linkTip = false;
				// 	}
				// }
				this.update();
			},
			// 修改
			update() {
				const that = this;
				that.loading = true;
				let requestData = {
					bannerId: that.obj.id,
					bannerTitle: that.title,
					bannerUrl: that.banner,
					linkUrl: that.link
				};
				Api.updateAppHomeSwiper(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 上传图片
			handleBannerUpload(e) {
				const that = this;
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadBanner(base64[0], imgs_type[0], imgs_name[0]);
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的图片
			handleBannerDelete() {
				this.banner = '';
			},
			// 上传图片
			uploadBanner(base64, img_type, fileName) {
				const that = this;
				that.loading = true;
				let postName = `${ new Date().getTime() }_${ fileName }`;
				let requestData = {
					base: base64,
					picName: postName,
					type: 'uGateWayUrl'
				};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.banner = res.data.data.imgUrl.split('?')[0];
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.loading = false;
					this.banner = this.obj.banner;
					this.title = this.obj.title;
					this.link = this.obj.link;
					this.bannerTip = false;
					this.titleTip = false;
					this.linkTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
